import { declOfNum } from 'ui/helpers/declOfNum';

import { GetLabelText } from './types';

export const getLabelTextDefault: GetLabelText = (count, size) => {
  let text = `Выбрано: ${count}`;

  const extended = size !== 'small' ? declOfNum(count, ['значение', 'значения', 'значений']) : '';

  if (extended) {
    text += ` ${extended}`;
  }

  return text;
};
